import { trpc } from '../../trpc/react';

export type UseKpiBenchmarksArgs = {
  trackId?: string;
};

/**
 * Loads KPI benchmark resolutions for every athlete on a track, keyed by
 * profileId (the KPI analog of {@link useExerciseBenchmarks} for the coach
 * Actuals page).
 */
export const useKpiBenchmarks = ({ trackId }: UseKpiBenchmarksArgs) => {
  const query = trpc.athleteKpiBenchmarks.getKpiBenchmarksForTrack.useQuery(
    { trackId: trackId ?? '' },
    {
      staleTime: 1000 * 60,
      enabled: !!trackId,
    },
  );

  return {
    kpiBenchmarksByProfile: query.data ?? {},
    isLoading: query.isLoading,
  };
};
